<template>
  <div class="main-view">
    <el-radio-group
      v-model="table.params.type"
      @change="handleTabs"
      style="margin-bottom: 10px"
    >
      <el-radio-button :label="1">待审核({{ table.total_1 }})</el-radio-button>
      <el-radio-button :label="2">已审核({{ table.total_2 }})</el-radio-button>
    </el-radio-group>
    <div class="section shadow filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params" size="mini">
        <el-form-item label="打款人" prop="name">
          <el-input
            clearable
            v-model.trim="table.params.name"
            placeholder="请输入"
            @clear="onSearch"
            @keydown.enter.native="onSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="充值日期" prop="date">
          <el-date-picker
            v-model="table.params.date"
            type="daterange"
            placeholder="选择日期"
            range-separator="至"
            start-placeholder="请选择"
            end-placeholder="请选择"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="用工单位" prop="company_name">
          <el-input
            clearable
            v-model.trim="table.params.company_name"
            placeholder="请输入"
            @clear="onSearch"
            @keydown.enter.native="onSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="审核结果" prop="status" v-if="table.params.type == 2">
          <el-select v-model="table.params.status" style="margin-right: 10px" clearable>
              <el-option label="已到账" :value="2"></el-option>
              <el-option label="未到账" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            class="theneBtn"
            type="primary"
            icon="el-icon-search"
            @click="onSearch"
            >查询
          </el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="display: flex; align-items: center; gap: 10px">
        <el-button type="primary" size="mini" @click="toRecharge"
          >我要充值</el-button
        >
        <div>
          <span style="margin-right: 10px"
            >累计充值￥{{ table.total_amount }}</span
          >
          <span style="margin-right: 10px"
            >已发放￥{{ table.yet_send_amount }}</span
          >
          <span style="margin-right: 10px"
            >待发放￥{{ table.await_send_amount }}
          </span>
          <span>剩余可用￥{{ table.surplus_amount }}</span>
        </div>
      </div>
    </div>

    <div class="curTableWrap" ref="main">
      <el-table
        :data="table.data"
        ref="tableDom"
        :height="tableHeight"
        border
        style="width: 100%"
        v-loading="table.loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0)"
        :header-cell-style="{ background: '#f5f5f5' }"
        class="chTable"
      >
        <el-table-column label="序号" type="index" width="60">
        </el-table-column>
        <el-table-column label="打款人名称" prop="name" min-width="100">
        </el-table-column>
        <el-table-column label="用工单位" prop="company_name" min-width="120">
        </el-table-column>
        <el-table-column label="充值金额" prop="amount" min-width="100">
          <template slot-scope="{ row }">￥{{ row.amount }}</template>
        </el-table-column>
        <el-table-column label="支付方式" prop="pay_type" min-width="100">
          <template slot-scope="{ row }">
            {{ { 1: "微信", 2: "银行卡" }[row.pay_type] }}
          </template>
        </el-table-column>
        <el-table-column label="充值日期" prop="reg_time" min-width="100">
        </el-table-column>
        <el-table-column
          label="创建时间"
          prop="create_time"
          show-overflow-tooltip
          min-width="130"
        >
          <template slot-scope="{ row }">
            <div>{{ row.create_time }}</div>
            <div>{{ row.create_name }}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="table.params.type == 2"
          label="审核时间"
          prop="check_time"
          show-overflow-tooltip
          min-width="130"
        >
          <template slot-scope="{ row }">
            <div>{{ row.check_time }}</div>
            <div>{{ row.check_name }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="审核结果"
          prop="status"
          v-if="table.params.type == 2"
          show-overflow-tooltip
          width="100"
        >
          <template slot-scope="{ row }">
            <div>
              {{ { 1: "待审核", 2: "已到账", 3: "未到账" }[row.status] }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          prop="action"
          fixed="right"
          width="160"
          v-if="table.params.type == 1"
        >
          <template slot-scope="{ row }">
            <el-popconfirm
              title="确认到账吗？"
              @confirm="reviewRow(row, 1)"
              style="margin-right: 6px"
            >
              <el-button slot="reference" type="text">确认到账</el-button>
            </el-popconfirm>

            <el-popconfirm title="确认未到账吗？" @confirm="reviewRow(row, 2)">
              <el-button slot="reference" type="text">未到账</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination__wrap">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="table.params.page"
          :page-size="table.params.count"
          :total="table.total"
          :page-sizes="[10, 20, 50, 100, 150]"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <rechargeDialog
      ref="rechargeDialogRef"
      @success="getTable"
    ></rechargeDialog>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
import { mixinTableHeight } from "@/mixins/tableHeight.js";
import rechargeDialog from "./components/rechargeDialog.vue";
import { getStorage } from "@/storage"
export default {
  components: {
    VTable,
    rechargeDialog,
  },
  mixins: [mixinTable, mixinTableHeight],
  data() {
    return {
      role_type:getStorage('role_type'),
      table: {
        loading: false,
        params: {
          type: 1,
          company_name: "",
          name: "",
          date: [],
          page: 1,
          count: 10,
        },
        data: [],
        total_1: 0,
        total_2: 0,
        total: 0,
        total_amount: 0,
        yet_send_amount: 0,
        await_send_amount: 0,
        surplus_amount: 0,
      },
      payInfo: {},
    };
  },
  created() {
    this.getTable();
  },
  methods: {
    getTable() {
      console.log(this.table.params, "this.table.params");
      let _params = { ...this.table.params };
      if(_params.date && _params.date.length){
        let [reg_time_start = "", reg_time_end = ""] = _params.date;
        _params.reg_time_start = reg_time_start;
        _params.reg_time_end = reg_time_end;
      }
      delete _params.date;
      if(_params.type != 2){
        delete _params.status;
      }
      this.$http
        .get("/admin/flex_salary/list", { params: _params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
            this.table.total_1 = res.data.total_1;
            this.table.total_2 = res.data.total_2;
            this.table.total_amount = res.data.total_amount;
            this.table.yet_send_amount = res.data.yet_send_amount;
            this.table.await_send_amount = res.data.await_send_amount;
            this.table.surplus_amount = res.data.surplus_amount;
            this.payInfo = {
              bank: res.data.bank,
              weChat: {
                ...res.data.weChat,
                // code_url:
                //   "https://qn.cdn.jszhr.com/wisdom/20260414/c22865b0c4d49734dfc4a5dbbc91b3c5.jpeg",
              },
            };
            this.$nextTick(() => {
              this.$refs.tableDom.doLayout();
            });
          }
        });
    },
    // 我要充值
    toRecharge() {
      let dom = this.$refs.rechargeDialogRef;
      // 先传数据再显示，避免弹窗打开瞬间残留上一次的收款信息
      dom.getDetail(this.payInfo);
      dom.toggle(true);
      dom = null;
    },
    reviewRow(row, status) {
      if(this.role_type != 1){
        this.$message.error("非管理员角色不支持操作")
        return
      }
      this.$http
        .post("/admin/flex_salary/check", { id: row.id, status })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("操作成功");
            this.getTable();
          }
        });
    },
  },
};
</script>
<style scoped lang="scss">
.curTableWrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 24px;
  background: #fff;
  flex: 1;
  overflow: hidden;
}
.pagination__wrap {
  margin: 10px 0;
  text-align: right;
  padding-right: 40px;
}
</style>